<template>
    <counsel-card-row label="분야" :cols="12" :md="4"> {{ areaText }} </counsel-card-row>
</template>

<script>
import counselCardRow from "./counsel-card-row.vue";
export default {
    components: { counselCardRow },
    props: ["area"],
    computed: {
        areaText() {
            if (this.area) return `${this.area.parent.name} > ${this.area.name}`;
            else return "";
        },
    },
};
</script>

<style></style>
